import { useQuery } from '@tanstack/react-query';
import { getDisclaimerText } from 'components/acquisitions/api/disclaimer';
import { DISCLAIMER_TEXT_QUERY_KEY_PREFIX } from 'components/acquisitions/constants/api';
import { QueryCacheTimes } from 'components/flowBuilder/constants';

const useDisclaimerText = (shopId: number) => {
  return useQuery({
    queryKey: [DISCLAIMER_TEXT_QUERY_KEY_PREFIX, shopId],
    queryFn: () => getDisclaimerText(shopId),
    staleTime: QueryCacheTimes.SHORT,
  });
};

export default useDisclaimerText;
